module.exports = __webpack_public_path__ + "img/spezia.bd743cdb.png";